module.exports = __webpack_public_path__ + "img/8.0d0d6395.jpg";